import { api } from "./project";

export const SUCCESS_API_RESPONSE = "success";

export const ContactApi = `${api}/contacts`;

export const ContactPersonalDataApi = `${api}/contacts/personal-data`;
export const ContactSocialDataApi = `${api}/contacts/social-data`;
export const ContactComunicationApi = `${api}/contacts/comunication-data`;

export const UserApi = `${api}/users`;
export const RolesApi = `${api}/roles`;
export const AuthApi = `${api}/auth`;
export const EntityApi = `${api}/entities`;
export const ChargeContactApi = `${api}/contact-charges`;
export const JurisdictionApi = `${api}/jurisdictions`;
export const PoliticSpaceApi = `${api}/politic-spaces`;
export const DistrictApi = `${api}/districts`;
export const BlockApi = `${api}/blocks`;
export const UserActivityApi = `${api}/reports/user-activity`;
export const AsesorsApi = `${api}/asesors`;

export const AreaApi = `${api}/areas`;
export const ComissionApi = `${api}/comissions`;
export const NotesApi = `${api}/notes`;
export const LinksApi = `${api}/links`;
export const FilesApi = `${api}/files`;
export const ProvincesApi = `${api}/provinces`;
export const CititesApi = `${api}/cities`;
